import styled, { css } from "styled-components";

export const VideoCallContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  .cursor--pointer {
    cursor: pointer;
  }

  .open--call {
    font-size: 2rem;
    color: #919191;

    &:hover {
      color: #1b72d6;
    }
  }

  .close--call {
    font-size: 2.3rem;
    color: #cc0000;
  }

  .invite--call {
    font-size: 1.5rem;
    color: #ffffff;
  }

  .blob-cam-invite {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    transform: scale(1);
    background-color: rgba(0, 168, 132, 1);
    box-shadow: 0 0 0 0 rgba(0, 168, 132, 1);
    animation: pulse-s 2s infinite;
    cursor: pointer;

    @keyframes pulse-s {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 168, 132, 0.7);
      }
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 168, 132, 0);
      }
      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 168, 132, 0);
      }
    }
  }
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 0.4rem;
  border-radius: 6px;
  border: 1px solid #e0e0e0;

  ${({ accessLevel }) =>
    accessLevel?.includes('ACESSIBILIDADE') &&
    css`
      background-color: #ffffff;
      border: 3px solid #000000;

      .video-call-button {
        .open--call,
        .dropdown-arrow {
          color: #000000 !important;
        }

        &:hover {
          .open--call,
          .dropdown-arrow {
            color: #000000 !important;
          }
        }
      }
  `}

  &:hover {
    background-color: ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') ? '#ffffff' : 'rgba(0, 0, 0, 0.05)'};
  }

  .video-call-button {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    cursor: pointer;
    padding: 0.15rem;
    transition: background-color 0.2s ease;

    .dropdown-arrow {
      font-size: 1.5rem;
      color: #919191;
      transition: transform 0.2s ease;
    }
  }

  .open--call {
    &:hover {
      color: #919191 !important;
    }
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 160px;
  overflow: hidden;
  margin-top: 0.25rem;
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') ? 'none' : '#f8f9fa'};
  }

  .call-icon {
    width: 20px;
    height: 20px;
    color: #919191;
  }

  span {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
`;

export const LoadingSpinner = styled.div`
  font-size: 4px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: mulShdSpin 1.1s infinite ease;
  transform: translateZ(0);
  margin: 0.5rem;

  @keyframes mulShdSpin {
    0%,
    100% {
      box-shadow: 0em -2.6em 0em 0em #1b72d6,
        1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2),
        2.5em 0em 0 0em rgba(27, 114, 214, 0.2),
        1.75em 1.75em 0 0em rgba(27, 114, 214, 0.2),
        0em 2.5em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em 1.8em 0 0em rgba(27, 114, 214, 0.2),
        -2.6em 0em 0 0em rgba(27, 114, 214, 0.5),
        -1.8em -1.8em 0 0em rgba(27, 114, 214, 0.7);
    }
    12.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(27, 114, 214, 0.7),
        1.8em -1.8em 0 0em #1b72d6, 2.5em 0em 0 0em rgba(27, 114, 214, 0.2),
        1.75em 1.75em 0 0em rgba(27, 114, 214, 0.2),
        0em 2.5em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em 1.8em 0 0em rgba(27, 114, 214, 0.2),
        -2.6em 0em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em -1.8em 0 0em rgba(27, 114, 214, 0.5);
    }
    25% {
      box-shadow: 0em -2.6em 0em 0em rgba(27, 114, 214, 0.5),
        1.8em -1.8em 0 0em rgba(27, 114, 214, 0.7), 2.5em 0em 0 0em #1b72d6,
        1.75em 1.75em 0 0em rgba(27, 114, 214, 0.2),
        0em 2.5em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em 1.8em 0 0em rgba(27, 114, 214, 0.2),
        -2.6em 0em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2);
    }
    37.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(27, 114, 214, 0.2),
        1.8em -1.8em 0 0em rgba(27, 114, 214, 0.5),
        2.5em 0em 0 0em rgba(27, 114, 214, 0.7), 1.75em 1.75em 0 0em #1b72d6,
        0em 2.5em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em 1.8em 0 0em rgba(27, 114, 214, 0.2),
        -2.6em 0em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2);
    }
    50% {
      box-shadow: 0em -2.6em 0em 0em rgba(27, 114, 214, 0.2),
        1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2),
        2.5em 0em 0 0em rgba(27, 114, 214, 0.5),
        1.75em 1.75em 0 0em rgba(27, 114, 214, 0.7), 0em 2.5em 0 0em #1b72d6,
        -1.8em 1.8em 0 0em rgba(27, 114, 214, 0.2),
        -2.6em 0em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2);
    }
    62.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(27, 114, 214, 0.2),
        1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2),
        2.5em 0em 0 0em rgba(27, 114, 214, 0.2),
        1.75em 1.75em 0 0em rgba(27, 114, 214, 0.5),
        0em 2.5em 0 0em rgba(27, 114, 214, 0.7), -1.8em 1.8em 0 0em #1b72d6,
        -2.6em 0em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2);
    }
    75% {
      box-shadow: 0em -2.6em 0em 0em rgba(27, 114, 214, 0.2),
        1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2),
        2.5em 0em 0 0em rgba(27, 114, 214, 0.2),
        1.75em 1.75em 0 0em rgba(27, 114, 214, 0.2),
        0em 2.5em 0 0em rgba(27, 114, 214, 0.5),
        -1.8em 1.8em 0 0em rgba(27, 114, 214, 0.7), -2.6em 0em 0 0em #1b72d6,
        -1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2);
    }
    87.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(27, 114, 214, 0.2),
        1.8em -1.8em 0 0em rgba(27, 114, 214, 0.2),
        2.5em 0em 0 0em rgba(27, 114, 214, 0.2),
        1.75em 1.75em 0 0em rgba(27, 114, 214, 0.2),
        0em 2.5em 0 0em rgba(27, 114, 214, 0.2),
        -1.8em 1.8em 0 0em rgba(27, 114, 214, 0.5),
        -2.6em 0em 0 0em rgba(27, 114, 214, 0.7), -1.8em -1.8em 0 0em #1b72d6;
    }
  }
`;

export const WrapperInCall = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.4rem 1.5rem 0.4rem 0.4rem;
  background: linear-gradient(
    135deg,
    ${(props) =>
    props.variant === 2
      ? "#00c896 0%, #00a884 100%"
      : "#ff5252 0%, #ff5252 100%"}
  );
  border-radius: 25px;

  ${({ accessLevel }) =>
    accessLevel?.includes('ACESSIBILIDADE') &&
    css`
      background: #ffffff;
      border: 3px solid #000000;

      .call-icon-wrapper {
        background: #ffffff;
        border: 1px solid #000000;
        &::after {
          border: 2px solid #000000;
        }
        .call-icon {
          color: #000000 !important;
        }
      }

      .call-text {
        color: #000000 !important;
      }
    `}

  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: 0 3px 6px
      ${(props) =>
    props.variant === 2
      ? "rgba(0, 168, 132, 0.7)"
      : "rgba(204, 0, 0, 0.7)"};
  }

  /* &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 168, 132, 0.4);
    background: linear-gradient(135deg, #00c896 0%, #00a884 100%);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 168, 132, 0.3);
  } */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s;
  }

  &:hover::before {
    left: 100%;
  }

  .call-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 30px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    animation: callPulse 2s infinite;
    position: relative;

    .call-icon {
      font-size: 1.2rem;
      color: #ffffff;
      z-index: 1;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      border: 2px solid rgba(255, 255, 255, 0.6);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      animation: callRipple 2s infinite;
    }
  }

  .call-text {
    color: #ffffff;
    font-weight: 600;
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  @keyframes callPulse {
    0%,
    100% {
      transform: scale(1);
      background: rgba(255, 255, 255, 0.2);
    }
    50% {
      transform: scale(1.1);
      background: rgba(255, 255, 255, 0.3);
    }
  }

  @keyframes callRipple {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.5);
      opacity: 0;
    }
  }

  @media (max-width: 768px) {
    padding: 0.6rem 0.8rem;
    gap: 0.5rem;

    .call-icon-wrapper {
      width: 28px;
      height: 28px;

      .call-icon {
        font-size: 1rem;
      }
    }

    .call-text {
      font-size: 0.8rem;
    }
  }

  ${(props) => props.disabled && css`
    cursor: default;
    opacity: 0.9;
    pointer-events: none; 
  `}
`;
